import { useEffect, useState } from 'react';
import { makeStyles } from "@mui/styles";
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import currencies from '@configs/bulkPurchaseCurrency';

const useStyles = makeStyles((theme) => ({
	rootFirstSelect: {
		padding: "10px 12px"
	},
	rootSecondSelect: {
		padding: "10px 80px"
	}
}));

export const CurrencyList = (props) => {
	const classes = useStyles();
	const { value, onChange, width, disabled, variant, label, background, compactView } = props;

	const changeHandler = (e) => {
		if (e && e.target && e.target.value) {
			onChange(e.target.value);
		}
	};

	return (
		<FormControl variant={variant} sx={{ width: width ? width : '100%' }}>
			{label && <InputLabel id="currency-list-label">{label}</InputLabel>}
			<Select
				onChange={changeHandler}
				placeholder="Select Curreny"
				value={currencies.length > 0 ? value : ''}
				label={label}
				disabled={disabled}
				sx={{ background: background }}
				classes={{ select: compactView ? classes.rootFirstSelect : '' }}
			>
				{currencies.map(({ code, name }) => (
					<MenuItem value={code} key={`option-id-${code}`}>
						{name} ({code})
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
};
